<template>
  <j-modal
    title="文件列表"
    :width="800"
    :visible="visible"
    :maskClosable="false"
    :switchFullscreen="false"
    :fullscreen="false"
    @ok="visible = false"
    @cancel="visible = false"
  >
    <template slot="footer">
      <a-button key="submit" type="default" @click="visible = false"> 关闭 </a-button>
    </template>
    <a-list item-layout="horizontal" :data-source="files">
      <a-list-item slot="renderItem" slot-scope="item, index">
        <a slot="actions" @click="preview(item)" v-if="previewSupport(item)"><a-icon type="eye" />预览</a>
        <a slot="actions" @click="download(item)"><a-icon type="download" />下载</a>
        {{ item }}
      </a-list-item>
    </a-list>
    <j-modal :visible="previewVisible" :fullscreen="true" :footer="null" @cancel="previewVisible = false">
      <img
        v-if="previewVisible"
        alt="example"
        @click="previewVisible = false"
        style="width: 100%"
        :src="previewImage"
      />
    </j-modal>
  </j-modal>
</template>
<script>
import { mixinDevice } from '@/utils/mixin'
import { downloadFile, getFileAccessHttpUrl } from '@/api/manageChooseSeat.js'
const getFileName = (path) => {
  if (path.lastIndexOf('\\') >= 0) {
    let reg = new RegExp('\\\\', 'g')
    path = path.replace(reg, '/')
  }
  return path.substring(path.lastIndexOf('/') + 1)
}
export default {
  name: 'FileView',
  props: {
    applicationCode: {
      type: String,
      default: 'chooseseat',
      required: false,
    },
  },
  mixins: [mixinDevice],
  components: {},
  data() {
    return {
      visible: false,
      path: null,
      previewVisible: false,
      previewImage: '',
    }
  },
  created() {},
  computed: {
    files() {
      return (this.path || '').split(',').filter((item) => item)
    },
    previewers() {
      return [{ name: 'image', suffixs: ['gif', 'jpg', 'jpeg', 'png', 'bmp', 'webp'] }]
    },
  },
  methods: {
    previewSupport(path) {
      var previewer = this.getPreviewer(path)
      return previewer
    },
    getPreviewer(path) {
      var fileName = getFileName(path) || ''
      var suffix = fileName.split('.').findLast((i) => true)
      var index = this.previewers.findIndex((previewer) => previewer.suffixs.includes(suffix))
      return index >= 0 ? this.previewers[index] : null
    },
    view(path) {
      this.visible = true
      this.path = path
    },
    preview(path) {
      var previewer = this.getPreviewer(path)
      if (previewer) {
        var method = this[`preview_${previewer.name}`]
        typeof method == 'function' && method.call(this, path)
      }
    },
    preview_image(path) {
      this.previewVisible = true
      this.previewImage = getFileAccessHttpUrl(path+"?applicationCode=chooseseat")
    },
    download(path) {
      var url = getFileAccessHttpUrl(path+"?applicationCode=chooseseat")
      var fileName = getFileName(path)
      downloadFile(url, fileName)
    },
  },
}
</script>
